import React, {useState, useEffect, useMemo, useRef, useContext, useCallback} from "react";
import {Bars} from "react-loader-spinner";
import {APOLLO_SYSTEM_ADMIN, APOLLO_GROUP_OPERATOR, ApolloUserProfileAuth} from "../../../atom/Apollo_Authorization";

import {
  Button,
  Card,
  CardActions,
  CardContent,
  Grid,
  LinearProgress,
} from "@material-ui/core";
import InputLabel from '@material-ui/core/InputLabel';
import Typography from "@material-ui/core/Typography";
import moment from "moment";
import {
  apollo_useStyles,
  options_state,
  options_state_edit,
  valueToOption,
  options_reviewstatus_for_view,
  options_zeus_campaign_type,
  ZEUS_DELIVERY_TYPE,
  options_zeus_pmp_type,
  option_zeus_adtype,
  ZEUS_AD_TYPE,
  valueToOptionNull,
  ZEUS_PMP_TYPE
} from "../../../atom/Apollo_styles";
import {ApolloMessage} from "../../../atom/Apollo_Mesasge";
import {
  ApolloBasicLabel,
  ApolloBasicSelect,
  ApolloBasicTextField
} from "../../../molecule/Apollo_BaseItem";
import {AdvertisementZeus, OptionPlacementSetting} from "./AdvertisementModelZeus";
import { AdTitle, AdDescription, AdImage, AdTag, AdVideo, ZeusAd, AdGroupRow } from "../../ADGROUP/zeus/AdGroupModelZeus";
import {
  zeus_ad_account, get_zeus_ad_group_path,
  get_zeus_campaign_path,
  get_zeus_placement_settings,
} from "../../../atom/Apollo_links";
import {ApiResponse, ApolloAxios, getResultType, isSuccessApi} from "../../../atom/Apollo_ApiRequest3";
import {
  getEditPermission,
} from "../../../atom/Apollo_Authorization";
import {checkUrlStr, getTextStrCheckErrorMsg, checkInvalidCharForName, checkDomainStr} from "../../../common/Apollo_CommonUtil";
  import {options_clicktoaction }  from "../../../atom/Apollo_styles";
import { ApolloContext } from "../../../atom/Apollo_Context";
import { CreativeTitles, CreativeDescriptions, CreativeImages,  CreativeTag} from "./CreativeEdit";
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import Divider from "@material-ui/core/Divider";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import Backdrop from "@material-ui/core/Backdrop";
import axios from "axios";
import {CampaignZeus} from "../../CAMPAIGN/zeus/CampaignModelZeus";

const animatedComponents = makeAnimated();
interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

function a11yProps(index: any) {
  return {
      id: `scrollable-auto-tab-${index}`,
      'aria-controls': `scrollable-auto-tabpanel-${index}`,
  }
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
      <div
          role="tabpanel"
          hidden={value !== index}
          id={`simple-tabpanel-${index}`}
          aria-labelledby={`simple-tab-${index}`}
          {...other} >
          {children}
      </div>
  )
}
type ZeusAdResourceFormProps = {
  titles: AdTitle[],
  setTitles: any,
  titleIndexes: number[],
  setTitleIndexes: any,
  isAddedTitle: boolean,
  setIsAddedTitle: any,
  descriptions: AdDescription[],
  setDescriptions: any,
  descriptionIndexes: number[],
  setDescriptionIndexes: any,
  isAddedDescription: boolean,
  setIsAddedDescription: any,
  images: AdImage[],
  setImages: any,
  imageIndexes: number[],
  setImageIndexes: any,
  isAddedImage: boolean,
  setIsAddedImage: any,
  selectedFileOrigins: string[],
  setSelectedFileOrigins: any,
  tags: AdTag[],
  setTags: any,
  tagIndexes: number[],
  setTagIndexes: any,
  isAddedTag: boolean,
  setIsAddedTag: any,
}

type ZeusAdvertisementFormProps = {
  platformAccountId: number,
  advertisementId: number,
  advertisementState: {
    advertisement: AdvertisementZeus,
    setAdvertisement: React.Dispatch<React.SetStateAction<AdvertisementZeus>>,
    deliveryType: number,
    setDeliveryType: any,
    pmpType: number | null,
    setPmpType: any,
    placementSettingId: number,
    setPlacementSettingId: any,
  },
  adResourceState: ZeusAdResourceFormProps,
  submitAction: any,
  goBackAction: any,
}

export type OptionCampaign = {
  value: number,
  label: string,
  deliveryType: number,
  pmpType: number | null,
}


export type OptionAdgroup = {
  value: number,
  label: string,
  placementSettingId: number,
}

type TemplateData = {
  id: number,
  name: string,
  img: {
    type: number,
    w: number,
    h: number,
    wmin: number,
    hmin: number,
  }
  data: {
    title: number,
    text: number,
    advertiserName: number,
    domain: number,
  }
}

type AssetRule = {
  title: number,
  text: number,
  advertiserName: number,
  domain: number,
}

const DEFAULT_IMAGE_RULE = {
  type: 1,
  maxWidth: 1,
  maxHeight: 1,
  minWidth: 1,
  minHeight: 1,
}

const DEFAULT_ASSET_RULE = {
  title: 25,
  text: 90,
  advertiserName: 25,
  domain: 100,
}

export const valueToOptionAdGroupSh = function (value: any, options: OptionAdgroup[]): OptionAdgroup {
  let option = options.find(option => option.value === value)
  if (!option) {
    return options[0]
  } else {
    return option
  }
}

// 画面名：広告作成（ZEUS）
const AdvertisementFormZeus = ({
                               platformAccountId,
                               advertisementId,
                               advertisementState,
                               adResourceState,
                               submitAction,
                               goBackAction,
                             }: ZeusAdvertisementFormProps) => {
  const classes = apollo_useStyles();
  const {state} = useContext(ApolloContext);
  const {control, errors, formState, handleSubmit, register} = useForm({mode: "onBlur", reValidateMode: "onBlur"});
  const isEditor = getEditPermission(state);
  const [openDialog, setOpenDialog] = useState(false);
  const [campaigns, setCampaigns] = useState<OptionCampaign[]>([]);
  const [optionAdGroups, setOptionAdGroups] = useState<OptionAdgroup[]>([]);
  const [optionPlacementSettings, setOptionPlacementSettings] = useState<OptionPlacementSetting[]>([]);
  const [assetRule, setAssetRule] = useState<AssetRule>(DEFAULT_ASSET_RULE);
  const canAssetEdit = useRef(advertisementId === 0);
  const processing = useRef(false);
  const [fetchingAdGroup, setFetchingAdGroup] = useState(false);
  const now = moment().format("YYYY-MM-DD");
  const [progress, setProgress] = useState(false);

  const zeusaccountid = platformAccountId;
  const adid = advertisementId;
  const {accountgroupid, accountid} = useParams<{
    accountgroupid: string,
    accountid: string,
  }>();
  const [placementSettingAdTypes, setPlacementSettingAdTypes] = useState<number[]>([]);

  // ローディング中のAPIコール数をカウントするステート
  const [loadingCount, setLoadingCount] = useState(0);

  // API開始時に +1、完了時に -1
  const startLoading = () => setLoadingCount(c => c + 1);
  const endLoading   = () => setLoadingCount(c => c - 1);

  useEffect(() => {
    const isLoading = loadingCount > 0;
    setProgress(isLoading);
    setmsg({ type: "loading", payload: { ...data, loading: isLoading } });
  }, [loadingCount]);

  useMemo(() => {
    if (advertisementState.advertisement.adGroupId === 0 || optionAdGroups.length === 0) return;
    const adGroup = optionAdGroups.find((aG) => aG.value === advertisementState.advertisement.adGroupId);
  }, [optionAdGroups.length]);

  const formHooks = useForm<FormData>();

  const fetchPlacementSetting = async () => {
    if (advertisementState.advertisement.adGroupId === 0) return;

      const placementSettingId = optionAdGroups.find((x) => x.value === advertisementState.advertisement.adGroupId)?.placementSettingId
      if (!placementSettingId || placementSettingId === 0) return;

      const url = `${process.env.REACT_APP_API_ENDPOINT}${get_zeus_placement_settings}/${placementSettingId}`;
      startLoading();
      await axios.get(url, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${state.accesstoken}`,
        }
      }).then((response) => {
        const data = response.data;
        if (!isSuccessApi(data.resultCode)) {
          return Promise.reject({
            open: true,
            type: getResultType(data.resultCode),
            errmsg: data?.message ? data.message : "プレースメント設定情報の取得に失敗しました",
          });
        }
        const resultPlacementSettingTypes: OptionPlacementSetting[] = data.result.placementSettingTypes
        setOptionPlacementSettings(resultPlacementSettingTypes)

        // プレースメントが許容する広告種別を抽出
        const resAdTypes = []
        for (const adTypeOption of option_zeus_adtype) {
          if (resultPlacementSettingTypes.some((x: any) => x.adType === adTypeOption.value)) {
            resAdTypes.push(adTypeOption.value)
          }
        }
        if (advertisementId === 0) {
          const firstAdType = resAdTypes.sort((a, b) => a - b)[0];
          advertisementState.setAdvertisement(prev => ({
            ...prev,
            adType: firstAdType,
            status: firstAdType === ZEUS_AD_TYPE.TAG_ASSET_VIDEO
              ? options_state.find(option => option.value === 1)!.value
              : options_state.find(option => option.value === 2)!.value
          }))
        }

        setPlacementSettingAdTypes(resAdTypes)
      })
      .catch((err) => {
        setmsg ({
            type: "setMessage",
            payload: {
                ...data,
                open:true,
                type:"error",
                message:"プレースメント設定情報の取得に失敗しました",
        }});
      }).finally(() => {
        endLoading();
      });
  }

  const LINK_MAX_LENGTH = 1800;
  
  const isValid =  useCallback((advertisement: AdvertisementZeus, adResourceState: ZeusAdResourceFormProps, deliveryType: number): boolean => {     
    if (advertisement.name === "" || advertisement.name.length > 255)  {console.log('1'); return false;}
    if (advertisement.adGroupId === 0) {console.log('2'); return false;}
    if (advertisement.link === "" || advertisement.link.length > LINK_MAX_LENGTH) {console.log('3'); return false;}
    if (advertisement.sponsor === "" || advertisement.sponsor.length > 20) return false;
    if (advertisement.adType !== ZEUS_AD_TYPE.TAG_ASSET_VIDEO) {
      if (adResourceState.selectedFileOrigins.length == 0 || adResourceState.selectedFileOrigins.length > 3) return false;
    }

    if (deliveryType === ZEUS_DELIVERY_TYPE.DSP) {
      if (advertisement.sponsorDomain === "" || advertisement.sponsor.length > 250) return false;
    }

    // 見出し・説明文の必須チェックは、必須となる広告種別でのみ判定する
    if (advertisement.adType === ZEUS_AD_TYPE.RESPONSIVE_IMAGE) {
      if (adResourceState.titles.length == 0 || adResourceState.titles.length > 3) return false;
      if (adResourceState.descriptions.length == 0 || adResourceState.descriptions.length > 3) return false;
      const localTitles = adResourceState.titles.filter((title: AdTitle) => (title.text === ""))
      if (localTitles.length > 0) return false
      const localDescriptions = adResourceState.descriptions.filter((description: AdDescription) => (description.text === ""))
      if (localDescriptions.length > 0) return false
    }
    if (advertisement.adType === ZEUS_AD_TYPE.TAG_ASSET_VIDEO) {
      if (adResourceState.tags.length == 0) return false;
    } else {
      const localSelectedFileOrigins = adResourceState.selectedFileOrigins.filter((fileOrigin: string) => (fileOrigin === ""))
      if (localSelectedFileOrigins.length > 0) return false
    }
    return true;
  },[{...adResourceState},formHooks.watch()])

  useEffect(() => {

    const fetchAccount = async () => {
      if (advertisementId !== 0) return;
      const path = `${zeus_ad_account}${platformAccountId}`;
      await ApolloAxios.get(path).then(response => {
        const res: ApiResponse = response.data;
        if (response.status !== 200) {
          return Promise.reject({
            open: true,
            type: getResultType(response.status === 400 ? -1 : -9),
            errmsg: "アカウント情報を取得できませんでした",
          });
        }
        advertisementState.setAdvertisement(prev => ({
          ...prev,
          sponsor: response?.data?.advertiserName,
        }));
      }).catch(err => {
        setmsg({
          type: "all",
          payload: {
            ...data,
            open: true,
            type: err.type,
            message: err.errmsg,
          }
        });
      });
    }

    const fetchCampaigns = async () => {
      if (advertisementId !== 0) return;
      // キャンペーン一覧情報取得
      const url = `${get_zeus_campaign_path}?account_id=${platformAccountId}&per_page=9999&page=1&sort=created&direction=desc`;
      await ApolloAxios.get(url).then(response => {
        if (response.status !== 200) {
          return Promise.reject({
            open: true,
            type: getResultType(response.status === 400 ? -1 : -9),
            errmsg: "キャンペーン情報を取得できませんでした",
          });
        }

        // const res: ApiResponse = response.data;
        // if (!isSuccessApi(res.resultCode)) {
        //   return Promise.reject({
        //     open: true,
        //     type: getResultType(res.resultCode),
        //     errmsg: res?.message ? res.message : "キャンペーン情報を取得できませんでした",
        //   });
        // }

        const campaigns: OptionCampaign[] = [];

        response.data?.map(function (data: { id: number, name: string, status: number, deliveryType: number, menuIds: number[], pmpType: number | null }) {
          if (data.status === 3) return;
          if (data.pmpType === undefined && data.deliveryType === ZEUS_DELIVERY_TYPE.DSP) {
            data.pmpType = null
          }
          const option = {
            value: data.id,
            label: `${data.id}_${data.name}`,
            menuId: 0,
            type: 0,
            deliveryType: data.deliveryType,
            pmpType: data.pmpType,
          }
          campaigns.push(option);
        });
        setCampaigns(campaigns);
      });
    }

    // キャンペーン情報等取得
    const fetchAll = async () => {
      processing.current = true;
      startLoading();
      setmsg({
        type: "loading",
        payload: {
          ...data,
          loading: true
        }
      });

      await Promise.all(
        [fetchAccount(), fetchCampaigns()]
      ).finally(async () => {
        await fetchPlacementSetting();
        processing.current = false;
        endLoading();
        setmsg({
          type: "loading",
          payload: {
            ...data,
            loading: false
          }
        });
      });
    }
    fetchAll();
  }, []);

  useEffect(() => {
    const func = async () => {
      if (advertisementState.advertisement.adCampaignId === 0) return;
      startLoading();
      setOptionAdGroups([]);

      setFetchingAdGroup(true);
      
      let url = `${process.env.REACT_APP_API_ENDPOINT}${get_zeus_ad_group_path}?account_id=${platformAccountId}&campaign_id=${advertisementState.advertisement.adCampaignId}&per_page=9999&page=1&sort=created&direction=desc`;
      await ApolloAxios.get(url).then(response => {
        const res: ApiResponse = response.data;

        if (response.status !== 200) {
          return Promise.reject({
            open: true,
            type: getResultType(response.status === 400 ? -1 : -9),
            errmsg: "広告グループ情報を取得できませんでした",
          });
        }

        const newOptionAdGroups: OptionAdgroup[] = [];
        response.data?.map(function (data: { id: number, name: string, status: number, placementSettingId: number}) {
          if (data.status === 3) return;
          const option: OptionAdgroup = {
            value: data.id,
            label: `${data.id}_${data.name}`,
            placementSettingId: data.placementSettingId,
          }
          newOptionAdGroups.push(option);
        });
        setOptionAdGroups(newOptionAdGroups);
        if (advertisementState.advertisement.adGroupId !== 0) {
          // 広告グループ一覧からの遷移時と編集時の初期表示の際はプレースメント設定IDを入れる契機がないためここでセット
          advertisementState.setPlacementSettingId(newOptionAdGroups.find((x) => x.value === advertisementState.advertisement.adGroupId)?.placementSettingId);
        }
      }).catch(err => {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: err.type,
            message: err.errmsg,
          }
        });
      }).finally(() => {
        setFetchingAdGroup(false);
      });

      const url2 = `${process.env.REACT_APP_API_ENDPOINT}${get_zeus_campaign_path}/${advertisementState.advertisement.adCampaignId}`
      await axios.get(url2, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${state.accesstoken}`,
        },
      }).then(response => {
        if (response.data) {
          const result: CampaignZeus = response.data
          if (result.pmpType === undefined && result.deliveryType === ZEUS_DELIVERY_TYPE.DSP) {
            result.pmpType = null
          }

          advertisementState.setDeliveryType(result.deliveryType);
          advertisementState.setPmpType(result.pmpType);
        }
      }).catch(err => {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: "Zeusキャンペーン種別の取得に失敗しました"
          }
        });
      });
      endLoading();
    }
    func();
  }, [advertisementState.advertisement.adCampaignId]);

  useEffect(() => {
    // プレースメント設定取得
    fetchPlacementSetting()
  }, [advertisementState.placementSettingId]);

  const handleClose = () => {
    if (openDialog) setOpenDialog(false);
  }

  const isTagAssetVideo = advertisementState.advertisement.adType === ZEUS_AD_TYPE.TAG_ASSET_VIDEO;

  const inputProps = {
    deliveryType: {
      id: "deliveryType",
      label: "キャンペーン種別",
      options: options_zeus_campaign_type,
    },
    pmpType: {
      id: "pmpType",
      label: "取引形式",
      options: options_zeus_pmp_type,
    },
    adCampaignId: {
      id: "adCampaignId",
      label: "キャンペーン",
      options: advertisementState.deliveryType === ZEUS_DELIVERY_TYPE.PERFORMANCE ? campaigns.filter(x => x.deliveryType === advertisementState.deliveryType) : campaigns.filter(x => x.deliveryType === advertisementState.deliveryType && x.pmpType === advertisementState.pmpType)
    },
    adGroupId: {
      id: "adGroupId",
      label: "広告グループ",
      options: optionAdGroups,
    },
    adType: {
      id: "adType",
      label: "広告種別",
      options: option_zeus_adtype.filter(x => x.deliveryType.includes(advertisementState.deliveryType)
      && (advertisementState.deliveryType === ZEUS_DELIVERY_TYPE.PERFORMANCE || x.pmpType.includes(advertisementState.pmpType))
      && (advertisementState.deliveryType === ZEUS_DELIVERY_TYPE.PERFORMANCE || advertisementState.pmpType === ZEUS_PMP_TYPE.OPEN_AUCTION || placementSettingAdTypes.includes(x.value))),
    },
    name: {
      id: "name",
      label: "広告名",
      type: "text",
      inputProps: {
        readOnly: !isEditor,
      },
      rules: {
        required: "必須入力項目です。",
        minLength: {
          value: 1,
          message: "1以上を入力して下さい。"
        },
        maxLength: {
          value: 255,
          message: "255文字以内で入力して下さい。"
        },
        validate: (e: string) => {
          const errorMessage = checkInvalidCharForName(e);
          if(errorMessage) {
            return errorMessage;
          }
        },
      },
      required: true,
    },
    status: {
      id: "status",
      label: "ステータス",
      readOnly: !isEditor,
      options: advertisementId === 0 ? isTagAssetVideo
        ? options_state.filter(option => option.value === 1)
        : options_state
      : options_state_edit,
    },
    reviewStatusForView: {
      id: "reviewStatusForView",
      label: "審査ステータス",
      readOnly: true,
      options: options_reviewstatus_for_view ,
    },
    cta: {
      id: "cta",
      label: "ClickToAction",
      readOnly:  (!isEditor || !canAssetEdit.current),
      options: options_clicktoaction,
    },
    title: {
      id: "title",
      label: "見出し",
      type: "text",
      inputProps: {
        readOnly: (!isEditor || !canAssetEdit.current),
      },
      rules: {
        required: "必須入力項目です。",
        min: {
          value: 1,
          message: "1以上を入力して下さい。"
        },
        max: {
          value: assetRule.title,
          message: `${assetRule.title}文字以内で入力して下さい。`
        },
        validate: (e: string) => {
          const errorMessage = checkInvalidCharForName(e);
          if(errorMessage) {
            return errorMessage;
          }
        },
      },
      required: true,
    },
    text: {
      id: "text",
      label: "説明文",
      type: "text",
      inputProps: {
        readOnly: (!isEditor || !canAssetEdit.current),
      },
      rules: {
        max: {
          value: assetRule.text,
          message: `${assetRule.text}文字以内で入力して下さい。`
        },
        validate: (e: string) => {
          const errorMessage = getTextStrCheckErrorMsg(e);
          if(errorMessage) {
            return errorMessage
          }
        },
      },
      required: false,
    },
    sponsor: {
      id: "sponsor",
      label: "情報提供者名",
      type: "text",
      inputProps: {
        readOnly:  (!isEditor || !canAssetEdit.current),
      },
      rules: {
        required: "必須入力項目です。",
        minLength: {
          value: 1,
          message: "1文字以上を入力して下さい。"
        },
        maxLength: {
          value: 20,
          message: "20文字以内で入力して下さい。"
        },
        validate: (e: string) => {
          const errorMessage = getTextStrCheckErrorMsg(e)
          if(errorMessage) {
            return errorMessage
          }
        },
      },
      required: true,
    },
    link: {
      id: "link",
      label: "最終リンク先URL",
      type: "text",
      inputProps: {
        readOnly:  (!isEditor || !canAssetEdit.current),
      },
      rules: {
        required: "必須入力項目です。",
        minLength: {
          value: 1,
          message: "1文字以上を入力して下さい。"
        },
        maxLength: {
          value: LINK_MAX_LENGTH,
          message: `${LINK_MAX_LENGTH}文字以内で入力して下さい。`
        },
        validate: (e: string) => {
          const errorMessage = checkUrlStr(e)
          if(errorMessage) {
            return errorMessage
          }
        },
      },
      required: true,
    },
    sponsorDomain: {
      id: "sponsorDomain",
      label: "情報提供者ドメイン",
      type: "text",
      inputProps: {
        readOnly: (!isEditor || !canAssetEdit.current),
      },
      rules: {
        required: advertisementState.deliveryType === ZEUS_DELIVERY_TYPE.DSP ? "必須入力項目です。" : undefined,
        minLength: advertisementState.deliveryType === ZEUS_DELIVERY_TYPE.DSP ? {
          value: 1,
          message: "1文字以上を入力して下さい。"
        } : undefined,
        maxLength: {
          value: 250,
          message: "250文字以内で入力して下さい。"
        },
        validate: (e: string) => {
          const errorMessage = checkDomainStr(e)
          if(errorMessage) {
            return errorMessage
          }
        },
      },
      required: advertisementState.deliveryType === ZEUS_DELIVERY_TYPE.DSP,
    },
  };

  const onSubmit = handleSubmit(async () => {
    if (processing.current) return;
    if (formState.isSubmitting) return;
    processing.current = true;

    if (!isValid(advertisementState.advertisement, adResourceState, advertisementState.deliveryType)) {
      setmsg ({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: "未設定の項目が存在します。"
        }
      });
      processing.current = false;
      return;
    }

    console.log('submitAction');
    setProgress(true);
    await submitAction();
    setProgress(false);
    processing.current = false;
  });


  const initZeusAds : ZeusAd = {
    id: 0,
    createdAt: "",
    updatedAt: "",
    lastUpdateUserId: "",
    adAccountId: 0,
    adCampaignId: 0,
    adGroupId: 0,
    name: "",
    status: 1,
    link: "",
    customUrl: "",
    sponsor: "",
    cta: 0,
    titles: [],
    descriptions: [],
    images: [],
    videos: [],
    apps: [],
    mails: [],
    tags: [],
    adAccountName: "",
    adCampaignName: "",
    adGroupName: "",
    reviewStatus: 0,
    reviewReason: 0,
    reviewStatusForView: 0,
  };

  const initAdGroupRow: AdGroupRow = {
    id: 0,
    createdAt: "",
    updatedAt: "",
    lastUpdateUserId: "",
    adAccountId: 0,
    adCampaignId: 0,
    name: "",
    status: 0,
    cpcLimit: null,
    eventRelations: [],
    osTargetings: [],
    demographicRelations: [],
    audienceRelations: [],
    segmentRelations: [],
  };
  let listErrors: { error: string; }[] = [];

  Object.keys(errors).forEach(key => {
      if (key === 'titles') {
          listErrors.push({error: '見出しを入力してください。'});
      }
      if (key === 'descriptions') {
          listErrors.push({error: '説明文を入力してください。'});
      }
      if (key === 'images') {
          listErrors.push({error: '画像を選択してください。'});
      }
  });

  // タブ制御
  const [tabstate, setTabstate] = React.useState( 0 );
  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
      setTabstate(newValue);
  };

  // クリエイティブ登録・編集
  const [titleIndexes, setTitleIndexes] = useState([1]);
  const [descriptionIndexes, setDescriptionIndexes] = useState([1]);
  const [imageIndexes, setImageIndexes] = useState([1]);
  // const [movieIndexes, setMovieIndexes] = useState([1]);


  const [zeusAds, setZeusAds] = useState<ZeusAd>(initZeusAds);
  const [adgroups, setAdGroups] = useState<AdGroupRow>(initAdGroupRow);

  const {data, setmsg} = useContext(ApolloMessage);

  /**
   * クリエイティブの入力フォームのindexを増やす。
   * @param {number} indexType - クリエイティブタイプ 1:見出し, 2:説明文, 3:画像, 4:動画
   */
  function addIndexes(indexType: number) {
      switch (indexType){
      case 1: // 見出し
          const curTitleIndexes = [...adResourceState.titleIndexes]
          const newTitleIndexes: number[] = [...curTitleIndexes, curTitleIndexes.length > 0 ? Math.max(...curTitleIndexes) + 1 : 0]
          adResourceState.setTitleIndexes(newTitleIndexes);
          break;
      case 2: // 説明文
          const curDescriptionIndexes = [...adResourceState.descriptionIndexes]
          const newDescriptionIndexes: number[] = [...curDescriptionIndexes, curDescriptionIndexes.length > 0 ? Math.max(...curDescriptionIndexes) + 1 : 0]
          adResourceState.setDescriptionIndexes(newDescriptionIndexes);
          break;
      case 3: // 画像
          const curImageIndexes = [...adResourceState.imageIndexes]
          const newImageIndexes: number[] = [...curImageIndexes, curImageIndexes.length > 0 ? Math.max(...curImageIndexes) + 1 : 0]
          adResourceState.setImageIndexes(newImageIndexes);
          break;
      case 4: // 動画
          // // @ts-ignore
          // setMovieIndexes(current => [...current, current.length > 0 ? Math.max(...current) + 1 : 0]);
          break;
      default:
      }
  }

  // クリエイティブ入力フォーム追加
  const addTitles = () => {
    adResourceState.setIsAddedTitle(true)
      if (adResourceState.titleIndexes.length >= 3) {
          return;
      }
      addIndexes(1);
      const localAdTitle: AdTitle = {text: "",}
      const newTitles: AdTitle[] = [...adResourceState.titles, localAdTitle]
      adResourceState.setTitles(newTitles);
  };
  const addDescriptions = () => {
    adResourceState.setIsAddedDescription(true);
      if (adResourceState.descriptionIndexes.length >= 3) {
          return;
      }
      addIndexes(2);
      const localAdDescription: AdDescription = {text: "",}
      const newAdDescriptions: AdDescription[] = [...adResourceState.descriptions, localAdDescription]
      adResourceState.setDescriptions(newAdDescriptions);
  };
  const addImages = () => {
    adResourceState.setIsAddedImage(true);
      if (adResourceState.imageIndexes.length >= 2) {
          return;
      }
      addIndexes(3);
      const newSelectedFileOrigins: string[] = [...adResourceState.selectedFileOrigins, ""]
      adResourceState.setSelectedFileOrigins(newSelectedFileOrigins);
  };

  // クリエイティブ入力フォーム削除
  const removeTitles =  (index: any) => ()  => {
      if (adResourceState.titleIndexes.length <= 1) {
          return;
      }
      const idx: number = adResourceState.titleIndexes.indexOf(Number(index))
      const newTitleIndexes: number[] = adResourceState.titleIndexes.filter(i => i !== Number(index))
      const newTitles: AdTitle[] = adResourceState.titles.filter((v, i) => i !== idx)
      adResourceState.setTitleIndexes(newTitleIndexes);
      adResourceState.setTitles(newTitles);
  };
  const removeDescriptions =  (index: any) => ()  => {
      if (adResourceState.descriptionIndexes.length <= 1) {
          return;
      }
      const idx: number = adResourceState.descriptionIndexes.indexOf(Number(index))
      const newDescriptionIndexes: number[] = adResourceState.descriptionIndexes.filter(i => i !== Number(index))
      const newAdDescriptions: AdDescription[] = adResourceState.descriptions.filter((v, i) => i !== idx)
      adResourceState.setDescriptionIndexes(newDescriptionIndexes);
      adResourceState.setDescriptions(newAdDescriptions);
  };
  const removeImages =  (index: any) => ()  => {
      if (adResourceState.imageIndexes.length <= 1) {
          return;
      }
      const idx: number = adResourceState.imageIndexes.indexOf(Number(index))
      const newImageIndexes: number[] = adResourceState.imageIndexes.filter(i => i !== Number(index))
      const newImages: string[] = adResourceState.selectedFileOrigins.filter((v, i) => i !== idx)
      adResourceState.setImageIndexes(newImageIndexes);
      adResourceState.setSelectedFileOrigins(newImages);
  };

 
  useEffect(() => {
    // 表示非表示が切り替わるためクリエイティブ情報のタブ選択をリセット
    setTabstate(0);
  }, [advertisementState.advertisement.adType]);

  const selectedReviewStatus =
  options_reviewstatus_for_view.find(
    opt => opt.value === advertisementState.advertisement.reviewStatusForView
  ) ?? null;

  return (
    <React.Fragment>
      <Backdrop className={classes.backdrop2} open={progress}>
        <Bars color="#00BFFF" height={80} width={80}/>
      </Backdrop>
      <form onSubmit={onSubmit}>
        <Card className={classes.root} square variant="outlined">
          <CardContent>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <ApolloBasicLabel label={"メニュー"} value={"パフォーマンス広告"}/>
              </Grid>
              <Grid item xs={12}>
                {advertisementId === 0
                  ? <ApolloBasicSelect
                    id={inputProps.deliveryType.id}
                    label={inputProps.deliveryType.label}
                    options={inputProps.deliveryType.options}
                    value={advertisementState.deliveryType}
                    control={control}
                    errors={errors.deliveryType}
                    onChange={() => {
                      advertisementState.setPmpType(ZEUS_PMP_TYPE.OPEN_AUCTION);
                      // NOTE: アセット画像情報は別コンポーネントが持っており削除できないため、画像のインデックスを貼り直すことで画像のクリアを実現している
                      adResourceState.setImageIndexes([adResourceState.imageIndexes.length > 0 ? Math.max(...adResourceState.imageIndexes) + 1 : 0]);
                      adResourceState.setSelectedFileOrigins([""]);
                      adResourceState.setTagIndexes([]);
                      adResourceState.setTags([])
                    }}
                    setState={(e: any) => {
                      advertisementState.setDeliveryType(e);
                      advertisementState.setAdvertisement(prev => ({
                        ...prev,
                        adCampaignId: 0,
                        adGroupId: 0,
                        adType: option_zeus_adtype.filter(x => x.deliveryType.includes(e))[0].value,
                      }));
                    }}
                  />
                  : <ApolloBasicLabel
                    label={inputProps.deliveryType.label}
                    value={valueToOptionNull(advertisementState.deliveryType, inputProps.deliveryType.options)?.label ?? ""}
                  />
                }
              </Grid>
              {advertisementState.deliveryType === ZEUS_DELIVERY_TYPE.DSP ?
              <Grid item xs={12}>
                {advertisementId === 0
                  ? <ApolloBasicSelect
                    id={inputProps.pmpType.id}
                    label={inputProps.pmpType.label}
                    options={inputProps.pmpType.options}
                    value={advertisementState.pmpType}
                    control={control}
                    errors={errors.pmpType}
                    onChange={() => {
                      // NOTE: アセット画像情報は別コンポーネントが持っており削除できないため、画像のインデックスを貼り直すことで画像のクリアを実現している
                      adResourceState.setImageIndexes([adResourceState.imageIndexes.length > 0 ? Math.max(...adResourceState.imageIndexes) + 1 : 0]);
                      adResourceState.setSelectedFileOrigins([""]);
                      adResourceState.setTagIndexes([]);
                      adResourceState.setTags([])
                    }}
                    setState={(e: any) => {
                      advertisementState.setPmpType(e);
                      advertisementState.setAdvertisement(prev => ({
                        ...prev,
                        adCampaignId: 0,
                        adGroupId: 0,
                        adType: option_zeus_adtype.filter(x => x.deliveryType.includes(advertisementState.deliveryType)
                        && (advertisementState.deliveryType === ZEUS_DELIVERY_TYPE.PERFORMANCE || x.pmpType.includes(e)))[0].value,
                      }));
                    }}
                  />
                  : <ApolloBasicLabel
                    label={inputProps.pmpType.label}
                    value={valueToOptionNull(advertisementState.pmpType, inputProps.pmpType.options)?.label ?? ""}
                  />
                }
              </Grid> : ""
              }
              <Grid item xs={12}>
                {advertisementId === 0 ?
                  <ApolloBasicSelect
                    id={inputProps.adCampaignId.id}
                    label={inputProps.adCampaignId.label}
                    options={inputProps.adCampaignId.options}
                    value={advertisementState.advertisement.adCampaignId}
                    control={control}
                    errors={errors.adCampaignId}
                    onChange={() => {
                      advertisementState.setAdvertisement(prev => ({
                        ...prev,
                        adGroupId: 0,
                      }));
                      // NOTE: アセット画像情報は別コンポーネントが持っており削除できないため、画像のインデックスを貼り直すことで画像のクリアを実現している
                      adResourceState.setImageIndexes([adResourceState.imageIndexes.length > 0 ? Math.max(...adResourceState.imageIndexes) + 1 : 0]);
                      adResourceState.setSelectedFileOrigins([""]);
                      adResourceState.setTags([])
                    }}
                    setState={(e: number) => {
                      advertisementState.setAdvertisement(prev => ({
                        ...prev,
                        adCampaignId: e,
                        adGroupId: 0,
                      }));
                    }}
                  />
                  : <ApolloBasicLabel label={"キャンペーン"}
                                      value={`${advertisementState.advertisement.adCampaignId}_${advertisementState.advertisement.adCampaignName}`}/>
                }
              </Grid>
              <Grid item xs={12}>
                {advertisementId === 0 ?
                  <ApolloBasicSelect
                    id={inputProps.adGroupId.id}
                    label={inputProps.adGroupId.label}
                    options={inputProps.adGroupId.options}
                    value={advertisementState.advertisement.adGroupId}
                    control={control}
                    disabled={advertisementState.advertisement.adCampaignId === 0 ? true : false}
                    errors={errors.adGroupId}
                    onChange={() => {
                      // NOTE: アセット画像情報は別コンポーネントが持っており削除できないため、画像のインデックスを貼り直すことで画像のクリアを実現している
                      adResourceState.setImageIndexes([adResourceState.imageIndexes.length > 0 ? Math.max(...adResourceState.imageIndexes) + 1 : 0]);
                      adResourceState.setSelectedFileOrigins([""]);
                      adResourceState.setTags([])
                    }}
                    setState={(e: number) => {
                      advertisementState.setAdvertisement(prev => ({
                        ...prev,
                        adGroupId: e,
                      }));
                      advertisementState.setPlacementSettingId(optionAdGroups.find((x) => x.value === e)?.placementSettingId);
                    }}
                  />
                  : <ApolloBasicLabel label={"広告グループ"}
                                      value={`${advertisementState.advertisement.adGroupId}_${advertisementState.advertisement.adGroupName}`}/>
                }
                {(advertisementId === 0 && fetchingAdGroup) &&
                <LinearProgress/>
                }
              </Grid>
              <Grid item xs={12}>
                {advertisementId === 0
                  ? <ApolloBasicSelect
                    id={inputProps.adType.id}
                    label={inputProps.adType.label}
                    options={inputProps.adType.options}
                    value={advertisementState.advertisement.adType}
                    control={control}
                    errors={errors.adType}
                    onChange={() => {
                      // NOTE: アセット画像情報は別コンポーネントが持っており削除できないため、画像のインデックスを貼り直すことで画像のクリアを実現している
                      adResourceState.setImageIndexes([adResourceState.imageIndexes.length > 0 ? Math.max(...adResourceState.imageIndexes) + 1 : 0]);
                      adResourceState.setSelectedFileOrigins([""]);
                      adResourceState.setTagIndexes([]);
                      adResourceState.setTags([])
                    }}
                    setState={(e: any) => {
                      advertisementState.setAdvertisement(prev => ({
                        ...prev,
                        adType: e,
                        // NOTE: タグアセット登録時はstatusが有効固定のため選択された時点で設定
                        status: e === ZEUS_AD_TYPE.TAG_ASSET_VIDEO && advertisementId === 0
                        ? options_state.find(option => option.value === 1)!.value
                        : options_state.find(option => option.value === 2)!.value
                      }))
                    }}
                  />
                  : <ApolloBasicLabel
                    label={inputProps.adType.label}
                    value={valueToOptionNull(advertisementState.advertisement.adType, inputProps.adType.options)?.label ?? ""}
                  />
                }
              </Grid>
              <Grid item xs={12}>
                <ApolloBasicTextField
                  id={inputProps.name.id}
                  label={inputProps.name.label}
                  type={inputProps.name.type}
                  value={advertisementState.advertisement.name}
                  inputProps={inputProps.name.inputProps}
                  inputRef={register(
                    inputProps.name.rules,
                  )}
                  error={errors.name}
                  required={inputProps.name.required}
                  setState={(e: any) => advertisementState.setAdvertisement(prev => ({
                    ...prev,
                    name: e
                  }))}
                />
              </Grid>
              <Grid item xs={12}>
                <ApolloBasicSelect
                  id={inputProps.status.id}
                  label={inputProps.status.label}
                  options={inputProps.status.options}
                  value={advertisementState.advertisement.status}
                  readOnly={inputProps.status.readOnly}
                  disabled={isTagAssetVideo ? true: false}
                  control={control}
                  errors={errors.status}
                  setState={(e: number) => 
                    advertisementState.setAdvertisement(prev => ({
                    ...prev,
                    status: e,
                  }))}
                />
              </Grid>
              <Grid item xs={12}>
                {advertisementId === 0 ? "" :
                <>
                  <InputLabel id="reviewStatusForView">
                    <Typography
                      variant="subtitle1"
                      color="textPrimary"
                    >
                      審査ステータス
                    </Typography>
                  </InputLabel>
                  <Select
                    inputId={inputProps.reviewStatusForView.id}
                    value={selectedReviewStatus}
                    options={options_reviewstatus_for_view}
                    isDisabled
                    isSearchable={false}
                    menuIsOpen={false}
                  />
                </>
                }
              </Grid>
              <Grid item xs={12}>
                <ApolloBasicTextField
                  id={inputProps.link.id}
                  label={inputProps.link.label}
                  type={inputProps.link.type}
                  value={advertisementState.advertisement.link}
                  inputProps={inputProps.link.inputProps}
                  inputRef={register(
                    inputProps.link.rules,
                  )}
                  error={errors.link}
                  required={inputProps.link.required}
                  onBlur={(e: any) => {
                    const link = String(e)
                    if (link === "") return;
                    if (advertisementState.advertisement.sponsorDomain !== "") return;

                    let sponsorDomain = ""
                    const errorMessage = checkUrlStr(link)
                    if (!errorMessage) {
                      const convertLink = new URL(link)
                      sponsorDomain = convertLink.host
                    }
                    advertisementState.setAdvertisement(prev => ({
                      ...prev,
                      sponsorDomain: sponsorDomain,
                    }))
                  }}
                  setState={(e: any) => advertisementState.setAdvertisement(prev => ({
                    ...prev,
                    link: e,
                  }))}
                />
              </Grid>
              <Grid item xs={12}>
                <ApolloBasicTextField
                  id={inputProps.sponsorDomain.id}
                  label={inputProps.sponsorDomain.label}
                  type={inputProps.sponsorDomain.type}
                  value={advertisementState.advertisement.sponsorDomain}
                  inputProps={inputProps.sponsorDomain.inputProps}
                  inputRef={register(
                    inputProps.sponsorDomain.rules,
                  )}
                  error={errors.sponsorDomain}
                  required={inputProps.sponsorDomain.required}
                  setState={(e: any) => advertisementState.setAdvertisement(prev => ({
                    ...prev,
                    sponsorDomain: e
                  }))}
                />
              </Grid>
              <Grid item xs={12}>
                <ApolloBasicTextField
                  id={inputProps.sponsor.id}
                  label={inputProps.sponsor.label}
                  type={inputProps.sponsor.type}
                  value={advertisementState.advertisement.sponsor}
                  inputProps={inputProps.sponsor.inputProps}
                  inputRef={register(
                    inputProps.sponsor.rules,
                  )}
                  error={errors.sponsor}
                  required={inputProps.sponsor.required}
                  setState={(e: any) => advertisementState.setAdvertisement(prev => ({
                    ...prev,
                    sponsor: e
                  }))}
                />
              </Grid>
              {advertisementState.advertisement.adType === ZEUS_AD_TYPE.RESPONSIVE_IMAGE ?
                <Grid item xs={12}>
                {advertisementId === 0 ?
                  <ApolloBasicSelect
                    id={inputProps.cta.id}
                    label={inputProps.cta.label}
                    options={inputProps.cta.options}
                    value={advertisementState.advertisement.cta}
                    readOnly={inputProps.cta.readOnly}
                    control={control}
                    errors={errors.cta}
                    setState={(e: number) => advertisementState.setAdvertisement(prev => ({
                      ...prev,
                      cta: e
                    }))}
                  />
                  : <ApolloBasicLabel label={inputProps.cta.label}
                  value={valueToOption(advertisementState.advertisement.cta, options_clicktoaction).label}/>
                }
                </Grid> : ""
              }
              <Divider />
              <Grid item xs={12}>
                <Typography variant="subtitle1" gutterBottom>
                  クリエイティブ情報
                </Typography>
                {advertisementState.advertisement.adType === ZEUS_AD_TYPE.RESPONSIVE_IMAGE ? 
                <Tabs value={tabstate} onChange={handleChange} aria-label="creative tabs">
                  <Tab label="見出し" {...a11yProps(0)} />
                  <Tab label="説明文" {...a11yProps(1)} />
                  <Tab label="広告アセット選択" {...a11yProps(2)} />
                  {/* <Tab label="動画" {...a11yProps(3)} /> */}
                </Tabs>
                :
                <Tabs value={tabstate} onChange={handleChange} aria-label="creative tabs">
                  <Tab label="広告アセット選択" {...a11yProps(2)} />
                </Tabs>
                }
                {advertisementState.advertisement.adType === ZEUS_AD_TYPE.RESPONSIVE_IMAGE ? 
                <TabPanel value={tabstate} index={0}>
                  <Grid item xs={12} style={{marginTop:"10px"}}>
                    <CreativeTitles
                      titleIndexes={adResourceState.titleIndexes}
                      addTitles={addTitles}
                      removeTitles={removeTitles}
                      formHooks={formHooks}
                      titles={adResourceState.titles}
                      isAddedTitle={adResourceState.isAddedTitle}
                      setTitles={adResourceState.setTitles}
                    />
                  </Grid>
                </TabPanel>
                : ""}
                {advertisementState.advertisement.adType === ZEUS_AD_TYPE.RESPONSIVE_IMAGE ? 
                <TabPanel value={tabstate} index={1}>
                  <Grid item xs={12} style={{marginTop:"10px"}}>
                    <CreativeDescriptions descriptionIndexes={adResourceState.descriptionIndexes}
                      addDescriptions={addDescriptions}
                      removeDescriptions={removeDescriptions}
                      formHooks={formHooks}
                      descriptions={adResourceState.descriptions}
                      isAddedDescription={adResourceState.isAddedDescription}
                      setDescriptions={adResourceState.setDescriptions}
                    />
                  </Grid>
                </TabPanel>
                : ""}
                <TabPanel value={tabstate} index={advertisementState.advertisement.adType === ZEUS_AD_TYPE.RESPONSIVE_IMAGE ? 2 : 0}>
                  <Grid item xs={12} style={{marginTop:"10px"}}>
                    {advertisementState.advertisement.adType === ZEUS_AD_TYPE.TAG_ASSET_VIDEO ?
                      <CreativeTag
                        tagIndexes={adResourceState.imageIndexes}
                        setTag={adResourceState.setTags}
                        tags={adResourceState.tags}
                        isAddedTag={adResourceState.isAddedTag}
                        platformAccountId={platformAccountId}
                        adGroupId={advertisementState.advertisement.adGroupId}
                        campaignType={advertisementState.deliveryType}
                        pmpType={advertisementState.pmpType}
                        optionPlacementSettings={optionPlacementSettings.filter(x => x.adType === advertisementState.advertisement.adType)}
                      />
                    :
                      <CreativeImages
                        imageIndexes={adResourceState.imageIndexes}
                        addImages={addImages}
                        removeImages={removeImages}
                        formHooks={formHooks}
                        images={adResourceState.images}
                        isAddedImage={adResourceState.isAddedImage}
                        accountid={accountid}
                        platformaccountid={platformAccountId}
                        zeuscampaignid={advertisementState.advertisement.adCampaignId}
                        accountgroupid={accountgroupid}
                        adgroupid={advertisementState.advertisement.adGroupId}
                        adid={adid}    
                        selectedFileOrigins={adResourceState.selectedFileOrigins}
                        setSelectedFileOrigins={adResourceState.setSelectedFileOrigins}
                        campaignType={advertisementState.deliveryType}
                        pmpType={advertisementState.pmpType}
                        optionPlacementSettings={optionPlacementSettings.filter(x => x.adType === advertisementState.advertisement.adType)}
                      />
                    }
                  </Grid>
                </TabPanel>
                {/*
                <TabPanel value={tabstate} index={3}>
                  <Grid item xs={12} style={{marginTop:"10px"}}>
                    <CreativeMovies movieIndexes={movieIndexes}
                      addMovies={addMovies}
                      removeMovies={removeMovies}
                      formHooks={formHooks}
                      videos={videos}
                      isAddedVideo={isAddedVideo}
                    />
                  </Grid>
                </TabPanel>
                */}
              </Grid>
            </Grid>
          </CardContent>
          <CardActions className={classes.cardaction}>
            <ApolloUserProfileAuth role={APOLLO_GROUP_OPERATOR} profile={APOLLO_SYSTEM_ADMIN}>
              <Button
                type="submit"
                color="primary"
                className={classes.button}
                onClick={onSubmit}
                variant="contained"
                  disabled={!isValid(advertisementState.advertisement, adResourceState, advertisementState.deliveryType) || processing.current}
              >
                {advertisementId === 0 ?
                  "作成" :
                  "更新"
                }
              </Button>
            </ApolloUserProfileAuth>
            <Button
              variant="contained"
              color="inherit"
              onClick={goBackAction}
              className={classes.button}
              disabled={processing.current}
            >
              {isEditor ? "キャンセル" : "戻る"}
            </Button>
          </CardActions>
        </Card>
      </form>
    </React.Fragment>
  )
};

export default AdvertisementFormZeus;
